'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var react = require('react');

var ToggleableContext = react.createContext({
    activeChildren: undefined,
    isActive: function (id) { return true; },
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    toggleActive: function (id) { }
});
var ToggleableContext$1 = ToggleableContext;

exports.default = ToggleableContext$1;
//# sourceMappingURL=ToggleableContext.js.map
